export const TRAINING_STATUSES = ["pending", "planned", "completed", "cancelled"] as const;
export type TrainingStatus = typeof TRAINING_STATUSES[number];
export const trainingStatusLabels: Record<TrainingStatus, string> = {
  pending: "Bekliyor", planned: "Planlandı", completed: "Tamamlandı", cancelled: "İptal edildi",
};
export function normalizeTrainingCode(value: string) {
  return value.trim().toUpperCase().replace(/\s+/g, "");
}
export function validTrainingCode(value: string) {
  return /^(TASK|BKM|TEK|TSK)[A-Z0-9][A-Z0-9./_-]{0,75}$/.test(value);
}
export interface TrainingRequest {
  id: string; course_id: string; user_id: string; display_name: string;
  organization_unit: string; main_team: string | null;
  status: TrainingStatus; planned_date: string | null; note: string;
  version: number; created_at: string; updated_at: string;
}
export interface TrainingCourse {
  id: string; code: string; name: string; version: number;
  pendingCount: number; plannedCount: number; activeCount: number;
  requests: TrainingRequest[];
}
export interface TrainingPayload {
  items: TrainingCourse[]; canManage: boolean; canRequest: boolean;
  recipientsReady: boolean; recipientNames: string[];
}
